/* PB Home landing — reveal-on-scroll + rotating announcement. Idempotent. */
(function () {
  if (window.__pbhInit) return;
  window.__pbhInit = true;

  function init() {
    /* Theme editor: sections re-render on every setting change, which would
       leave fresh .pbh-rv nodes stuck at opacity 0. In design mode, disable
       the reveal effect entirely via a root class (survives re-renders). */
    if (window.Shopify && window.Shopify.designMode) {
      document.documentElement.classList.add('pbh-design');
    }

    /* reveal on scroll */
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('in');
            io.unobserve(e.target);
          }
        });
      }, { threshold: 0.08 });
      document.querySelectorAll('.pbh-rv').forEach(function (el) { io.observe(el); });
    } else {
      document.querySelectorAll('.pbh-rv').forEach(function (el) { el.classList.add('in'); });
    }

    /* Horizontal shelves: mouse users can't scroll an overflow-x container with
       a plain wheel and there's no native drag-to-scroll. Add both. */
    initShelves(document);

    /* Move quick-buy overlays out of the shelf/card. Inside the horizontal
       scroll container they get clipped (and a transformed card would trap the
       fixed popover), so relocate them to <body>. Toggles find them by id, so
       DOM position doesn't matter. */
    relocateOverlays(document);

    /* predictive product search under the nav search bars */
    initSearch(document);

    /* magazine marquee: user-draggable while still auto-scrolling */
    initMag(document);

    /* Sticky masthead: expose the announcement height so the chrome section
       wrapper can pin at top:-announceHeight (announcement scrolls away,
       nav stays). Re-measured on resize; 0 when no announcement renders. */
    function setAnnH() {
      var an = document.querySelector('.pbh-announce');
      document.documentElement.style.setProperty('--pbh-ann-h', (an ? an.offsetHeight : 0) + 'px');
    }
    setAnnH();
    window.addEventListener('resize', setAnnH);

    /* rotating announcement messages */
    var an = document.querySelector('[data-pbh-announce]');
    if (an) {
      var msgs = [];
      try { msgs = JSON.parse(an.getAttribute('data-pbh-announce')) || []; } catch (err) { msgs = []; }
      var sp = an.querySelector('span');
      if (sp && msgs.length > 1) {
        var i = 0;
        setInterval(function () {
          i = (i + 1) % msgs.length;
          sp.style.opacity = 0;
          setTimeout(function () { sp.innerHTML = msgs[i]; sp.style.opacity = 1; }, 250);
        }, 3200);
      }
    }
  }

  /* Relocate quick-buy popovers/drawers rendered inside shelves to <body>. */
  function relocateOverlays(root) {
    (root || document).querySelectorAll('.pbh-shelf quick-buy-popover, .pbh-shelf quick-buy-drawer').forEach(function (el) {
      if (el.__pbhMoved || !document.body) return;
      el.__pbhMoved = true;
      document.body.appendChild(el);
    });
  }

  /* Predictive product search (Aug 2026). Attaches to each .pbh-search form
     (desktop bar + mobile row). Queries Shopify's public suggest endpoint,
     renders a small product panel under the form (thumb / title / price)
     plus a "search for" row that submits the form. The plain GET form stays
     the no-JS fallback. Idempotent per form. */
  function initSearch(root) {
    (root || document).querySelectorAll('form.pbh-search').forEach(function (form) {
      if (form.__pbhPs) return;
      form.__pbhPs = true;

      var input = form.querySelector('input[type="search"]');
      if (!input || !window.fetch) return;

      var panel = document.createElement('div');
      panel.className = 'pbh-ps';
      panel.hidden = true;
      form.appendChild(panel);

      var timer = null, ctrl = null, lastQ = '';

      function esc(s) {
        var d = document.createElement('div');
        d.textContent = s == null ? '' : s;
        return d.innerHTML;
      }

      function close() { panel.hidden = true; panel.innerHTML = ''; lastQ = ''; }

      function render(q, products, collections) {
        if (!products.length && !collections.length) { close(); return; }
        var html = '';
        /* Collections group first (parity with the pre-redesign native search
           drawer, which suggested collections alongside products). Compact
           text rows under a microlabel; capped at 4. */
        if (collections.length) {
          html += '<div class="pbh-ps-h">Collections</div>';
          html += collections.slice(0, 4).map(function (c) {
            return '<a class="pbh-ps-c" href="' + esc(c.url) + '">' + esc(c.title) + '</a>';
          }).join('');
          if (products.length) html += '<div class="pbh-ps-h">Products</div>';
        }
        html += products.map(function (p) {
          var img = (p.featured_image && p.featured_image.url) || p.image || '';
          var src = img ? img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=120' : '';
          return '<a class="pbh-ps-i" href="' + esc(p.url) + '">'
            + (src ? '<img loading="lazy" src="' + esc(src) + '" alt="">' : '')
            + '<span>' + esc(p.title) + '</span>'
            + (p.price ? '<b>$' + esc(p.price) + '</b>' : '')
            + '</a>';
        }).join('');
        html += '<button type="submit" class="pbh-ps-all">Search for “' + esc(q) + '”</button>';
        panel.innerHTML = html;
        panel.hidden = false;
      }

      input.addEventListener('input', function () {
        var q = input.value.trim();
        clearTimeout(timer);
        if (q.length < 2) { close(); return; }
        timer = setTimeout(function () {
          if (q === lastQ) return;
          lastQ = q;
          if (ctrl) ctrl.abort();
          ctrl = window.AbortController ? new AbortController() : null;
          fetch('/search/suggest.json?q=' + encodeURIComponent(q)
              + '&resources[type]=product,collection&resources[limit]=6&resources[options][unavailable_products]=last',
              ctrl ? { signal: ctrl.signal } : undefined)
            .then(function (r) { return r.json(); })
            .then(function (d) {
              if (q !== lastQ) return; /* stale response */
              var res = d && d.resources && d.resources.results;
              render(q, (res && res.products) || [], (res && res.collections) || []);
            })
            .catch(function () {});
        }, 220);
      });

      input.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
      input.addEventListener('focus', function () {
        if (input.value.trim().length >= 2) { lastQ = ''; input.dispatchEvent(new Event('input')); }
      });
      document.addEventListener('click', function (e) { if (!form.contains(e.target)) close(); });
    });
  }

  /* Give each shelf mouse drag-to-scroll + wheel-to-horizontal. Idempotent. */
  /* Magazine cover marquee (pb-home-magazine): the ambient auto-scroll used
     to be a pure CSS keyframe, so swipes/drags did nothing. Replace it (when
     pointer events exist) with a JS-driven loop the user can grab: drag or
     horizontal trackpad scroll moves the strip directly, auto-drift pauses,
     then resumes ~1.6s after release. Seamless wrap via the duplicated half
     tracks. Falls back to the CSS animation (no drag) on old browsers and
     stays static under prefers-reduced-motion (existing CSS). */
  function initMag(root) {
    if (!window.PointerEvent || !window.requestAnimationFrame) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    (root || document).querySelectorAll('.pbh-mag--auto').forEach(function (mag) {
      if (mag.__pbhMag) return;
      var vp = mag.querySelector('.pbh-mag-vp');
      var track = mag.querySelector('.pbh-mag-t');
      if (!vp || !track) return;
      mag.__pbhMag = true;
      mag.classList.add('pbh-mag--drag'); /* CSS kills the keyframe animation */

      var half = 0, offset = 0, dragging = false, holdUntil = 0;
      var startX = 0, startOff = 0, moved = 0, lastT = 0;
      var speed = parseFloat(getComputedStyle(mag).getPropertyValue('--pbh-mag-speed')) || 45; /* s per half-loop */

      function measure() { half = track.scrollWidth / 2; }
      measure();
      window.addEventListener('resize', measure);

      function wrap(v) {
        if (half <= 0) return 0;
        v = v % half;
        return v < 0 ? v + half : v;
      }

      function tick(t) {
        if (!lastT) lastT = t;
        var dt = Math.min(t - lastT, 100); /* clamp tab-switch jumps */
        lastT = t;
        if (!dragging && t > holdUntil && !mag.matches(':focus-within')) {
          offset = wrap(offset + (half / (speed * 1000)) * dt);
        }
        track.style.transform = 'translateX(' + -offset + 'px)';
        requestAnimationFrame(tick);
      }
      requestAnimationFrame(tick);

      /* Capture the pointer only AFTER real movement: capturing on
         pointerdown re-targets the derived click to the viewport, which
         silently killed every cover-link click (bug, Aug 6 pm). A plain
         tap/click never captures, so it reaches the link untouched. */
      var pressed = false;
      vp.addEventListener('pointerdown', function (e) {
        if (e.button) return;
        pressed = true; moved = 0; startX = e.clientX; startOff = offset;
      });
      vp.addEventListener('pointermove', function (e) {
        if (!pressed) return;
        var dx = e.clientX - startX;
        if (Math.abs(dx) > moved) moved = Math.abs(dx);
        if (!dragging && moved > 6) {
          dragging = true;
          try { vp.setPointerCapture(e.pointerId); } catch (err) {}
        }
        if (dragging) offset = wrap(startOff - dx);
      });
      function release() {
        if (!pressed) return;
        pressed = false;
        if (dragging) {
          dragging = false;
          holdUntil = performance.now() + 1600;
        }
      }
      vp.addEventListener('pointerup', release);
      vp.addEventListener('pointercancel', release);
      /* a real drag must not fire the cover link it ended on */
      vp.addEventListener('click', function (e) {
        if (moved > 6) { e.preventDefault(); e.stopPropagation(); }
      }, true);
      vp.addEventListener('dragstart', function (e) { e.preventDefault(); });
      /* sideways trackpad/wheel scroll moves it too */
      vp.addEventListener('wheel', function (e) {
        if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) {
          offset = wrap(offset + e.deltaX);
          holdUntil = performance.now() + 1200;
          e.preventDefault();
        }
      }, { passive: false });
    });
  }

  function initShelves(root) {
    (root || document).querySelectorAll('.pbh-shelf').forEach(function (shelf) {
      if (shelf.__pbhScroll) return;
      shelf.__pbhScroll = true;

      var down = false, moved = false, startX = 0, startLeft = 0;

      shelf.addEventListener('pointerdown', function (e) {
        if (e.button !== 0 || e.pointerType === 'touch') return; // touch scrolls natively
        down = true; moved = false;
        startX = e.clientX; startLeft = shelf.scrollLeft;
      });
      shelf.addEventListener('pointermove', function (e) {
        if (!down) return;
        var dx = e.clientX - startX;
        if (!moved && Math.abs(dx) > 4) {
          moved = true;
          shelf.classList.add('pbh-dragging');
          try { shelf.setPointerCapture(e.pointerId); } catch (err) {}
        }
        if (moved) { shelf.scrollLeft = startLeft - dx; e.preventDefault(); }
      });
      function endDrag() { down = false; shelf.classList.remove('pbh-dragging'); }
      shelf.addEventListener('pointerup', endDrag);
      shelf.addEventListener('pointercancel', endDrag);
      shelf.addEventListener('mouseleave', endDrag);
      /* Swallow the click that follows a drag so card links don't navigate. */
      shelf.addEventListener('click', function (e) {
        if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
      }, true);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Safety net for editor re-renders outside design mode detection */
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('.pbh-rv').forEach(function (el) { el.classList.add('in'); });
    initShelves(e.target);
    relocateOverlays(e.target);
    initSearch(e.target);
    initMag(e.target);
  });

  /* Quick-add is handled by the theme's own product-form / quick-buy-drawer
     components rendered inside pb-home-card — no custom cart JS needed. */
})();
